module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.49ae09db.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/Rubik-Regular/Rubik-Regular.woff
// module id = 1294
// module chunks = 49